// листинг в каталоге

// import { createApp } from "vue";
import { createApp } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js';
import { prettyMoney } from '../../../../assets/site/js/lib.js';
import { ref , reactive } from 'vue';

function initCartPageReactive(){

    const el = document.querySelector( '#basket-detail' );
    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();
                    const promo_code = ref( '' );

                    function isUnique( parameter ){
                        return parameter.values.find( item => item.is_unique );
                    }

                    function gotoOrder(){
                        if( contextStore.getBasketTotalCount() ){
                            window.location = '/checkout';
                        }
                    }

                    // contextStore.queryBasket();

                    return {
                        contextStore,
                        isUnique,
                        prettyMoney,
                        gotoOrder,
                        promo_code
                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initCartPageReactive );
